import React from "react";
import { useParams } from "react-router-dom";
import AWSInfraList from "./AWSInfraList";
import AzureInfraList from "./AzureInfraList";

const InfraStructureList = () => {
  const { name } = useParams();
  const infraType = name?.toLowerCase();

  const renderInfraList = () => {
    switch (infraType) {
      case "aws":
        return <AWSInfraList />;
      case "azure":
        return <AzureInfraList />;
      default:
        return <div>Unsupported infrastructure type</div>;
    }
  };

  return renderInfraList();
};

export default InfraStructureList;
